var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column",staticStyle:{"overflow":"hidden"}},[_c('NotFoundMeteor',{staticClass:"flex"},[_c('p',[_vm._v("Ops! Algo deu errado.")]),_vm._v(" "),_c('small',[_c('code',[_vm._v(_vm._s(_vm.$route.fullPath))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3786f86","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NotFound/index.vue
// module id = null
// module chunks = 